import React from "react";
import { PhoneIcon } from "lucide-react";
import { firm, footerGroups, RESULTS_PATH } from "../data/site";
import { SiteLink } from "./SiteLink";
export function SiteFooter() {
  return <footer className="on-dark bg-ink text-white" data-id="element-365" data-mp="3mh13ychob839">
      <div className="page-container py-14 md:py-16" data-id="element-366" data-mp="3mfq1qh3vm8e9">
        <div className="grid gap-10 md:grid-cols-12" data-id="element-367" data-mp="3hizixm0osyp5">
          <div className="md:col-span-6" data-id="element-368" data-mp="3hgddpt19qva3">
            <p className="text-h3 font-bold" data-id="element-369" data-mp="3dhe3pu0ok8bs">{firm.displayName}</p>
            <p className="mt-1 text-white/80" data-id="element-370" data-mp="3dei5e4kx7hmt">
              Michigan motorcycle injury representation.
            </p>
            <a href={firm.phoneHref} className="mt-5 inline-flex min-h-[48px] items-center gap-3 text-h3 font-extrabold text-white hover:underline" data-id="element-371" data-mp="33if5749mpt2i">
              <PhoneIcon aria-hidden="true" className="h-6 w-6" data-id="element-372" data-mp="11r1yqas0jd4c" />
              {firm.phoneDisplay}
            </a>
            <div className="mt-3" data-id="element-373" data-mp="wrpfe00coo6i">
              <SiteLink path="/contact-us/" className="inline-flex min-h-[44px] items-center text-label font-semibold text-white underline underline-offset-4" data-id="element-374" data-mp="wsqq23dgf8np">
                Contact the firm
              </SiteLink>
            </div>
          </div>
          {footerGroups.map(group => <nav key={group.id} aria-labelledby={group.id} className="md:col-span-3" data-id="element-375" data-mp="vtz73f9rczko">
              <h2 id={group.id} className="text-label font-bold text-white/80" data-id="element-376" data-mp="10stoccs2ug2o">
                {group.label}
              </h2>
              <ul className="mt-3" data-id="element-377" data-mp="1oi4te6ggmwmm">
                <li data-id="element-378" data-mp="1tg6esy1cz819"><SiteLink path={RESULTS_PATH} className="inline-flex min-h-[48px] items-center text-label font-bold text-white underline underline-offset-4" data-id="element-379" data-mp="1tg6d8tlpmzz5">Results</SiteLink></li>
                {group.links.map(link => <li key={link.path} data-id="element-380" data-mp="1jpl6ujzsor5o">
                    <SiteLink path={link.path} className="inline-flex min-h-[44px] items-center text-label font-semibold text-white underline-offset-4 hover:underline" data-id="element-381" data-mp="1jojt27re9qk9">
                      {link.label}
                    </SiteLink>
                  </li>)}
              </ul>
            </nav>)}
        </div>
        <div className="mt-12 flex flex-col gap-3 border-t border-white/20 pt-6 text-meta text-white/80 md:flex-row md:items-center md:justify-between" data-id="element-382" data-mp="2h1qffxjss543">
          <p data-id="element-383" data-mp="2823f7f2t15cm">© 2026 {firm.legalName}</p>
          <SiteLink path="/privacy-policy/" className="inline-flex min-h-[44px] items-center font-semibold text-white underline underline-offset-4" data-id="element-384" data-mp="28595gxn66d9x">Privacy Policy</SiteLink>
        </div>
      </div>
    </footer>;
}